import React, { ReactNode } from 'react'
import { ButtonLink } from '@shared/components/button-link'
import { Section } from '@shared/components/section'
import cx from 'classnames'

import styles from './style.module.scss'

export interface ComfortFormatBlock {
	id: number
	Icon: any
	title: ReactNode
	items: string[]
	btnText: string
	href: string
}

interface Props {
	blocks: ComfortFormatBlock[]
}

const ComfortBlock = ({ title, Icon, items, btnText, href }: ComfortFormatBlock) => {
	return (
		<div className={styles.comfortBlock}>
			<Icon className={styles.icon} />
			<h3 className={styles.comfortBlockTitle}>{title}</h3>
			<ul className={styles.list}>
				{items.map((item) => (
					<li key={item} className='on-style-type'>
						{item}
					</li>
				))}
			</ul>
			<ButtonLink href={href} className={styles.btn}>
				{btnText}
			</ButtonLink>
		</div>
	)
}

export const View = ({ blocks }: Props) => {
	return (
		<Section fullWidth className={styles.wrapper}>
			<div className={styles.row}>
				<h2 className={styles.sectionTitle}>Работайте с Credit.Club в&nbsp;удобном вам формате</h2>
				<div className={styles.sectionDesc}>
					<h3 className={styles.descTitle}>
						Сопровождайте сделки самостоятельно или отправляйте заявки по реферальной ссылке
					</h3>
					<p>
						Выбирать только один формат не обязательно — можно быть нашим партнёром и одновременно
						приводить клиентов по реферальной ссылке.{' '}
					</p>
				</div>
			</div>
			<div className={cx(styles.row, styles.rowComfortBlock)}>
				{blocks.map((block) => (
					<ComfortBlock key={block.id} {...block} />
				))}
			</div>
		</Section>
	)
}
